import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X2AgeCategoryStore} from '../X2AgeCategoryStore';

@observer
export class EditLevelControls extends React.Component<{ store: X2AgeCategoryStore }> {
  render() {
    const {store} = this.props;

    if (store.editLevel === null)
      return null;

    const editLevel = store.editLevel;
    const isPending = editLevel.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeEdit}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={editLevel.save} align="right"/>
    </>);
  }
}
